module.exports = __webpack_public_path__ + "img/SES_192422300.0a01ee14.jpg";